import htmlparser from 'htmlparser';

export const extractIdFromHtmlElement = (node) => {
  if (node.type !== 'parsedHtml' || !node.value) {
    return null;
  }
  const handler = new htmlparser.DefaultHandler((error) => {
    if (error) {
      console.error(error);
    }
  });
  const html = node.value && node.value.trim();
  const parser = new htmlparser.Parser(handler);
  parser.parseComplete(html);

  return (
    handler.dom &&
    handler.dom[0] &&
    handler.dom[0].attribs &&
    handler.dom[0].attribs.id
  );
};
